/* custom-button-item.tsx generated by @compiled/babel-plugin v0.36.1 */
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "onClick"];
import "./custom-button-item.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { ButtonItem } from '@atlaskit/side-navigation';
import { DN500 } from '@atlaskit/theme/colors';
var itemStyles = null;
export function CustomButtonItem(_ref) {
  var children = _ref.children,
    onClick = _ref.onClick,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(ButtonItem, _extends({
    onClick: onClick
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
  }, rest, {
    className: ax(["_bfhk3nif _lswu1fjw _syaz13q9 _irr3ebx2 _30l313q9 _1di6j4ot _9h8h13q9"]),
    style: {
      "--_1qpk0k2": ix("".concat("var(--ds-text, ".concat(DN500, ")")))
    }
  }), children);
}